import { render, staticRenderFns } from "./AssignRedactorModal.vue?vue&type=template&id=f1d45424&scoped=true&"
import script from "./AssignRedactorModal.vue?vue&type=script&lang=js&"
export * from "./AssignRedactorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d45424",
  null
  
)

export default component.exports